import { gql } from '@apollo/client';

const CREATE_INVOICE = gql`
  mutation createInvoice($invoice: InvoiceCreateInput!, $order: ID) {
    createInvoice(invoice: $invoice, order: $order) {
      success
      message
      invoice {
        id
      }
    }
  }
`;

const UPDATE_INVOICE = gql`
  mutation updateInvoice($id: ID!, $invoice: InvoiceUpdateInput!) {
    updateInvoice(id: $id, invoice: $invoice) {
      success
      message
      invoice {
        id
      }
    }
  }
`;

export { CREATE_INVOICE, UPDATE_INVOICE }
